import { Slider, Stack, Text, useMantineTheme } from '@mantine/core'
import { IconZoomInFilled, IconZoomOutFilled } from '@tabler/icons-react'
import React, { MutableRefObject, useCallback } from 'react'
import Cropper, { ReactCropperElement } from 'react-cropper'
import { Trans, useTranslation } from 'react-i18next'

import RootButton from '@/components/Buttons/RootButton'

interface CropItemsModalProps {
  asset: string
  cropperRef: MutableRefObject<ReactCropperElement>
  onConfirm: () => void
}

const CropItemsModal: React.FC<CropItemsModalProps> = ({ asset, cropperRef, onConfirm }) => {
  const { t } = useTranslation()
  const theme = useMantineTheme()

  const handleZoomLabel = useCallback((value: number) => `${(value * 100).toFixed(0)}%`, [])

  const handleZoom = useCallback(
    (value: number) => {
      if (typeof cropperRef.current?.cropper !== 'undefined') {
        cropperRef.current.cropper.zoomTo(value)
      }
    },
    [cropperRef]
  )

  return (
    <>
      <Trans i18nKey="components.studio.cropImageText.body">
        <Text style={{ fontSize: '16px' }}>
          This 1:1 selection will be used to preview your item across LAMINA1. The uncropped image
          will be minted platform and fully viewable on its Item Details page.
        </Text>
      </Trans>
      <Trans i18nKey="components.studio.cropImageText.zoomInfo">
        <Text
          style={{
            marginTop: '10px',
            fontSize: '14px',
            color: theme.colors.textAndIcon[0],
          }}
        >
          Zoom in, click, and drag to crop your image.
        </Text>
      </Trans>

      <Cropper
        style={{
          width: '300px',
          height: '300px',
          margin: '16px auto auto auto',
        }}
        src={asset}
        ref={cropperRef}
        aspectRatio={1} // Set aspectRatio to 1 for a 1:1 square aspect ratio
        viewMode={1}
        guides
        background={false}
        responsive
        checkOrientation={false}
      />

      <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: 16, marginTop: 20 }}>
        <IconZoomOutFilled size={24} style={{ color: theme.colors.textAndIcon[0] }} />
        <Slider
          defaultValue={0.1}
          step={0.01}
          min={0}
          max={1}
          label={handleZoomLabel}
          style={{ width: '100%' }}
          onChange={handleZoom}
        />
        <IconZoomInFilled size={24} style={{ color: theme.colors.textAndIcon[0] }} />
      </Stack>

      <Stack style={{ flexDirection: 'row', marginTop: '20px' }}>
        <RootButton onClick={onConfirm} expand style1={false}>
          {t('buttons.confirm', 'Confirm')}
        </RootButton>
      </Stack>
    </>
  )
}

export default CropItemsModal
